'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  gameWidth: 375,
  gameHeight: 667,
  localStorageName: 'dotgame',
  webfonts: ['Bangers']
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 129
// module chunks = 0